export class SendReferralModel {
  ReferralID: string;
  ReferrerID: number;
  ReferredID:  number;
  ReferrerInfo: string;
  ReferredInfo: string;
  ClientInfo: string;
  Status: string;
  ReferralCommission: string;
  NoOfDays: number;
}

export class SendReferralFormModel {
  senderFirstName: string;
  senderLastName: string;
  senderAgentID: string;
  senderCompany: string;
  senderEmail: string;
  senderAddress: string;
  senderAdditionalComments: string;
  clientFullName: string;
  clientEmail: string;
  clientPhoneNumber: string;
  clientAdditionPhoneNumber: string;
  typeOfAgent: string;
  referralCommission: string;
  receiverFirstName: string;
  receiverLastName: string;
  receiverAgentID: string;
  receiverCompany: string;
  receiverEmail: string;
  receiverAddress: string;
  budget: string;
  preferredCity: string;
  type: string;
  numberOfDays: number;
}


// // Referral Listing : Start
export class ReferralListingModel {
  senderName: string;
  receiverName: string;
  status: string;
  referralID: string;
  dateCreated: string;
}

export class ReferralSearchEntityModel {
  IsReferrer: boolean;
  PageNo: number;
  PageSize: number;
  SortOrder: string;
  SortBy : string;
}

export class DropDownFilter {
  DisplayText: string;
  DropDownValue: string[];
}

export class DropdownValues {
  Text: string;
  Value: string;
}


export class ReferralCommissionModel {
  ReferralID: string;
  TransactionStatus: boolean;
  TransactionAmount: number;
}


// // Referral Listing : End
